import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const STATUS = {
  sent: { label: "Gönderildi", cls: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100" },
  mock: { label: "Mock", cls: "bg-amber-100 text-amber-700 hover:bg-amber-100" },
  failed: { label: "Başarısız", cls: "bg-red-100 text-red-700 hover:bg-red-100" },
  skipped: { label: "Atlandı", cls: "bg-slate-100 text-slate-600 hover:bg-slate-100" },
};

export const WhatsAppLogsTable = ({ logs }) => (
  <Card className="border-slate-200 overflow-hidden" data-testid="whatsapp-logs-table">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-600">
          <tr>
            <th className="text-left p-4 font-medium">Gönderim</th>
            <th className="text-left p-4 font-medium">Program Tarihi</th>
            <th className="text-left p-4 font-medium">Çalışan</th>
            <th className="text-left p-4 font-medium">Telefon</th>
            <th className="text-right p-4 font-medium">İş</th>
            <th className="text-left p-4 font-medium">Tetik</th>
            <th className="text-left p-4 font-medium">Durum</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {logs.length === 0 && <tr><td colSpan={7} className="text-center py-10 text-slate-400" data-testid="whatsapp-logs-empty">Henüz gönderim yok</td></tr>}
          {logs.map((l) => {
            const s = STATUS[l.status] || STATUS.skipped;
            return (
              <tr key={l.id} className="hover:bg-slate-50" data-testid={`whatsapp-log-${l.id}`}>
                <td className="p-4 font-mono text-xs text-slate-600">{new Date(l.created_at).toLocaleString("tr-TR")}</td>
                <td className="p-4 text-slate-700">{new Date(l.schedule_date).toLocaleDateString("tr-TR")}</td>
                <td className="p-4 font-medium text-slate-900">{l.employee_name}</td>
                <td className="p-4 font-mono text-xs text-slate-600">{l.to ? `+${l.to}` : "-"}</td>
                <td className="p-4 text-right text-slate-700">{l.job_count}</td>
                <td className="p-4 text-slate-600 capitalize">{l.trigger}</td>
                <td className="p-4">
                  <Badge className={s.cls}>{s.label}</Badge>
                  {l.error && l.status !== "mock" && <div className="text-xs text-red-500 mt-1 max-w-xs truncate" title={l.error}>{l.error}</div>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </Card>
);
